export default __webpack_public_path__ + "static/media/Product-Listing.bd82fce9.svg";